import Icon from '../components/Icon.vue'

Icon.register({
  'external-link-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 24V152C576 173.4 550 184 535 169L499.3 133.2 255.8 376.8C246.4 386.1 231.2 386.1 221.9 376.8L199.2 354.1C189.9 344.8 189.9 329.6 199.2 320.2L442.8 76.7 407.1 41C392 25.9 402.7 0 424 0H552C565.3 0 576 10.7 576 24zM407 270.8L391 286.8A24-24 0 0 1 384 303.8V448H64V128H328A24-24 0 0 1 345 121L361 105C376.1 89.9 365.4 64 344 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V287.8C448 266.4 422.1 255.7 407 270.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/external-link-alt.js
// module id = LlPG
// module chunks = 144